import Service, { type Registry as Services, service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import type { SupportedCurrencies } from 'frontend-utils/utils/constants/currency-mapping-constants';

const CURRENCY_LOCAL_STORAGE_KEY = 'selectedCurrency';

export default class CurrencyService extends Service {
  @service declare localStorage: Services['local-storage'];

  @tracked selectedCurrency: SupportedCurrencies | null;

  constructor(...args: ConstructorParameters<typeof Service>) {
    super(...args);

    this.selectedCurrency = this.localStorage.getItem(
      CURRENCY_LOCAL_STORAGE_KEY,
    ) as SupportedCurrencies;
  }

  resetCurrency(): void {
    this.selectedCurrency = null;
    this.localStorage.removeItem(CURRENCY_LOCAL_STORAGE_KEY);
  }

  setCurrency(currency: SupportedCurrencies | null): void {
    if (!currency) {
      this.resetCurrency();
    } else {
      this.selectedCurrency = currency;
      this.localStorage.setItem(CURRENCY_LOCAL_STORAGE_KEY, currency);
    }
  }
}

declare module '@ember/service' {
  interface Registry {
    currency: CurrencyService;
  }
}
